import { Button, Space } from 'antd';
import React from 'react';
import RowMoreActions from '@/components/RowMoreActions';

function flatten(
  nodes: React.ReactNode,
  parentKey = '',
): React.ReactElement<any>[] {
  return React.Children.toArray(nodes).flatMap((node, index) => {
    if (!React.isValidElement<{ children?: React.ReactNode }>(node)) return [];
    const key = `${parentKey}/${node.key ?? index}`;
    return node.type === React.Fragment || node.type === Space
      ? flatten(node.props.children, key)
      : [React.cloneElement(node, { key })];
  });
}

export default function DetailActions({ children }: React.PropsWithChildren) {
  const actions = flatten(children);
  const primary = actions.find(
    (action) => action.type === Button && action.props.type === 'primary',
  );
  const ordered = primary
    ? [primary, ...actions.filter((action) => action !== primary)]
    : actions;
  const visible = ordered.length > 3 ? ordered.slice(0, 2) : ordered;
  const remaining = ordered.slice(visible.length);
  // Only actual buttons can become menu items. Retain composed controls as controls.
  const overflow = remaining.filter((action) => action.type === Button);
  const composed = remaining.filter((action) => action.type !== Button);
  return (
    <Space wrap size={8}>
      {visible.map((action, index) =>
        React.cloneElement(action, {
          key: action.key ?? index,
          ...(action.type === Button &&
          action !== primary &&
          action.props.type === 'primary'
            ? { type: 'default' }
            : {}),
        }),
      )}
      {composed}
      <RowMoreActions
        items={overflow.map((action, index) => ({
          key: String(action.key ?? index),
          label: action.props.children,
          danger: action.props.danger,
          disabled: action.props.disabled || action.props.loading,
          onClick: (event) => action.props.onClick?.(event.domEvent),
        }))}
      />
    </Space>
  );
}
